<template>
    <component
        :is="componentNameForType"
        :registrationData="registrationData"
    ></component>
</template>

<script>
    import ComponentFactory from '../../components/pagesbuilder/dynamic-components/ComponentFactory.vue';
    import PreviewAvatarComponent from './PreviewAvatarComponent.vue';
    import PreviewCourseCardsComponent from './PreviewCourseCardsComponent.vue';
    import PreviewBundleCardsComponent from './PreviewBundleCardsComponent.vue';
    import PreviewSubscriptionCardsComponent from './PreviewSubscriptionCardsComponent.vue';
    import PreviewBlogPostCardsComponent from './PreviewBlogPostCardsComponent.vue';
    import PreviewBlogPostListComponent from "./PreviewBlogPostListComponent";
    import PreviewBlogAboveTheFoldComponent from './PreviewBlogAboveTheFoldComponent.vue';
    import PreviewNavigationMenuComponent from './PreviewNavigationMenuComponent.vue';
    import PreviewDailyNewsCardsComponent from './PreviewDailyNewsCardsComponent.vue';
    import PreviewCommunityPostCardsComponent from './PreviewCommunityPostCardsComponent.vue';
    import PreviewCourseContentsComponent from './PreviewCourseContentsComponent.vue';
    import PreviewPaymentOptionsComponent from "./PreviewPaymentOptionsComponent";
    import PreviewUserStatsComponent from "./PreviewUserStatsComponent";
    import PreviewCourseEnrollComponent from "./PreviewCourseEnrollComponent";
    import PreviewSubscriptionPurchaseComponent from "./PreviewSubscriptionPurchaseComponent";
    import PreviewBundlePurchaseComponent from "./PreviewBundlePurchaseComponent";
    import PreviewFiltersComponent from "./PreviewFiltersComponent";
    import PreviewActionTriggerComponent from "./PreviewActionTriggerComponent";
    import PreviewProductCheckoutComponent from "./PreviewProductCheckoutComponent";
    import PreviewHamburgerMenuComponent from "./PreviewHamburgerMenuComponent";
    import PreviewPaymentMessagesComponent from "./PreviewPaymentMessagesComponent";
    import PreviewPaymentProductDetailsComponent from "./PreviewPaymentProductDetailsComponent";
    import PreviewPaymentAuthenticationComponent from "./PreviewPaymentAuthenticationComponent";
    import PreviewPaymentMethodComponent from "./PreviewPaymentMethodComponent";
    import PreviewPaymentBillingInfoComponent from "./PreviewPaymentBillingInfoComponent";
    import PreviewBundleDataComponent from "./PreviewBundleDataComponent";
    import PreviewCopyrightComponent from "./PreviewCopyrightComponent";
    import PreviewTimerComponent from "./PreviewTimerComponent";
    import PreviewBlogPostFiltersComponent from "./PreviewBlogPostFiltersComponent";

    export default {
        mixins: [ComponentFactory],
        data () {
            return {
                envNamePrefix: "Preview"
            }
        },
        components: {
            PreviewAvatarComponent,
            PreviewActionTriggerComponent,
            PreviewCourseCardsComponent,
            PreviewFiltersComponent,
            PreviewBundleCardsComponent,
            PreviewBundlePurchaseComponent,
            PreviewCopyrightComponent,
            PreviewSubscriptionCardsComponent,
            PreviewSubscriptionPurchaseComponent,
            PreviewBlogPostCardsComponent,
            PreviewBlogPostListComponent,
            PreviewHamburgerMenuComponent,
            PreviewBlogAboveTheFoldComponent,
            PreviewNavigationMenuComponent,
            PreviewDailyNewsCardsComponent,
            PreviewCommunityPostCardsComponent,
            PreviewCourseContentsComponent,
            PreviewCourseEnrollComponent,
            PreviewPaymentOptionsComponent,
            PreviewProductCheckoutComponent,
            PreviewUserStatsComponent,
            PreviewPaymentMessagesComponent,
            PreviewPaymentProductDetailsComponent,
            PreviewPaymentAuthenticationComponent,
            PreviewPaymentMethodComponent,
            PreviewPaymentBillingInfoComponent,
            PreviewBundleDataComponent,
            PreviewTimerComponent,
            PreviewBlogPostFiltersComponent,
        }
    }
</script>
